/**
 * Prototype tooling is strictly opt-in via VITE_PROTOTYPE_TOOLS === "true".
 * A missing, empty or malformed value MUST resolve to disabled.
 */
export const PROTOTYPE_TOOLS_ENABLED = import.meta.env['VITE_PROTOTYPE_TOOLS'] === 'true';

export const APP_NAME = 'PipeMitra Admin Portal';

/**
 * Origin of the Hono API, from root `.env` `API_BASE_URL`. Empty keeps relative
 * `/api` paths so the Vite proxy still works.
 */
declare const __PIPEMITRA_API_BASE_URL__: string | undefined;

export const API_BASE_URL = normalizeApiBaseUrl(
  typeof __PIPEMITRA_API_BASE_URL__ === 'string' ? __PIPEMITRA_API_BASE_URL__ : '',
);

function normalizeApiBaseUrl(value: unknown): string {
  if (typeof value !== 'string') return '';
  return value.trim().replace(/\/+$/, '');
}
